<footer>
  <p>
    Developed by
    <a
      href="https://www.linkedin.com/in/lcollares"
      target="_blank"
      rel="noopener noreferrer"
    >
      Leandro Collares
    </a>
    &middot; Source:
    <a
      href="https://www150.statcan.gc.ca/t1/tbl1/en/tv.action?pid=1410001101&pickMembers%5B0%5D=2.2&pickMembers%5B1%5D=3.1&pickMembers%5B2%5D=4.1&cubeTimeFrame.startMonth=01&cubeTimeFrame.startYear=2019&cubeTimeFrame.endMonth=09&cubeTimeFrame.endYear=2021&referencePeriods=20190101%2C20210901"
      target="_blank"
      rel="noopener noreferrer"
    >
      Statistics Canada
    </a>
  </p>
</footer>

<style>
  footer {
    margin-top: 5px;
    max-width: 600px;
  }

  p {
    line-height: 25px;
    text-align: center;
  }

  a {
    color: #4427ca;
    text-decoration-thickness: 0.0625rem;
    text-underline-offset: 0.1em;
  }

  a:visited {
    color: #4427ca;
  }

  a:active {
    color: #dc267f;
    text-decoration-thickness: 0.2rem;
  }

  a:hover {
    color: #dc267f;
    text-decoration-thickness: 0.2rem;
  }
</style>
